import { request } from '@/network/request'

export const userDataReport=(id)=>{
  return request({
    url: '/intelligentDetection/user/userDataReport?userId='+id,
    method: 'get',
  })
}

export const microQuestionnaire=(data)=>{
  return request({
    url: '/stroke/tWzaiStroke/microQuestionnaire',
    method: 'get',
    params:data
  })
}
export const getBeatReportList = (data) => {
  return request({
    url: '/api/familyManagement/homePage/getBeatReportList',
    method: 'post',
    params:data
  })
}

export const getBeatSignReport = (data) => {
  return request({
    url: '/api/beatSign/aiBeatSignReport/getBeatSignReport',
    method: 'post',
    params:data
  })
}

export const reportList=(data)=>{
  return request({
    url: '/intelligentDetection/user/reportList',
    method: 'get',
    params:data
  })
}

export const userDataReportChart=(data)=>{
  return request({
    url: '/intelligentDetection/user/userDataReportChart',
    method: 'get',
    params:data
  })
}


export const AIDiagnosis=()=>{
  return request({
    url: '/intelligentDetection/user/AIDiagnosis',
    method: 'get'
  })
}


export const diagnosisList=(data)=>{
  return request({
    url: '/intelligentDetection/user/diagnosisList',
    method: 'get',
    params:data
  })
}



export const AIDiagnosisType=(data)=>{
  return request({
    url: '/intelligentDetection/user/AIDiagnosisType',
    method: 'get',
    params:data
  })
}


//下载微体检模板
export function exportwtj(){
  return request({
    url: '/personalCenter/healthManagement/export',
    method: 'get',
  })
}
//   /*上传文件*/
export function ExecutorFlies (query) {
  return request({
    url: '/personalCenter/healthManagement/import',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/dataReport.js